'use strict';
var React = require('react');
var FormatMessage = require('react-globalize').FormatMessage;

const promotionDisclaimers = {
  "bfg_carousel_01.jpg": "Promoción valida desde el 1ro hasta el 10 de Mayo del 2016. Todos los clientes que realicen un envío de dinero durante estas fechas serán elegibles para participar en la rifa. El recibo del envío será su ticket de la rifa. Si no desea participar en la rifa, por favor envíe una carta con su nombre, dirección y número de teléfono al Departamento de Mercadeo de Barri localizado en 10777 Westheimer Road, Suite 1040, Houston,TX 77042, USA. No es necesario que realice un envío de dinero para participar. Si usted desea participar en la rifa, por favor envíe una carta declarando su intención de participar con su nombre, dirección y número de teléfono al Departamento de Mercadeo de Barri localizado en 10777 Westheimer Road, Suite 1040, Houston,TX 77042, USA. Todas las cartas de intención para participar deben ser recibidas antes del 05/10/2016, y únicamente aceptaremos una carta por persona. Los ganadores serán elegidos el o alrededor del 05/11/2016 (fecha sujeta a cambio sin previo aviso) en un sorteo al azar entre todas las inscripciones elegibles. Los ganadores serán notificados por teléfono. Si un ganador no responde después de dos avisos, perderá el derecho a su premio y un ganador alterno será seleccionado. Los premios serán certificados para realizar compras en La Michoacana Meat Market con un valor aproximado de $14,000. No ofrecemos garantía(s) por los premios entregados. “Promoción disponible únicamente en tiendas Barri dentro de la Michoacana Meat Market."
}

var SectionPromotion = React.createClass({

  getInitialState: function () {
    return {
      locale: this.props.locale,
      images: []
    }
  },

  handleLocaleChange: function (language) {
    this.setState({
      locale: language
    });
  },

  loadImagesFromServer() {
    $.ajax({
      url: '/api/carousel',
      type: 'POST',
      dataType: 'json',
      cache: false,
      success: function (data) {
        console.log("loadImagesFromServer");
        console.log(data);
        this.setState({ images: data });
      }.bind(this),
      error: function (xhr, status, err) {
        console.error(this.props.url, status, err.toString());
      }.bind(this)
    });
  },

  carouselClick(e, image){
    //console.log("carouselClick");
    //console.log(image);
    //$('#imgModal').modal('show');
    this.setState({
      selectedImage: "img/carousel/"+image,
      promDisclaimer: promotionDisclaimers[image]
    })
    $('#imgModal').modal('show');
  },

  componentDidMount() {
    this.loadImagesFromServer();
  },

  /**
   * @return {object}
   */
  render: function () {
    let self = this;
    var indents = (this.state.images).map(function (i) {
      return (
        <div className="item" key={i} onClick={(e)=>{self.carouselClick(e, i)}}>
          <img src={"img/carousel/" + i} alt="poster-michoacana" id="michoacana" className="center-block zoom img-thumbnail" />
        </div>
      );
    });
    return (
      <div id="section0" className="main-content">
        <div className="modal fade " id="imgModal" tabIndex="-1" role="dialog" aria-labelledby="myLargeModalLabel">
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-body">
                <img src={this.state.selectedImage} alt="" className="center-block" id="detailImage" />
              </div>
              <div className="modal-footer">
                <div id="imgModalDisclaimer" className="text-justify">
                  <p>
                    {this.state.promDisclaimer}
                  </p>
                </div>
              </div>

            </div>
          </div>
        </div>

        <div id="myCarousel" className="carousel slide" data-ride="carousel">
          <ol className="carousel-indicators">
            <li data-target="#myCarousel" data-slide-to="0" className="active"></li>
            <li data-target="#myCarousel" data-slide-to="1"></li>
            <li data-target="#myCarousel" data-slide-to="2"></li>
          </ol>

          <div className="carousel-inner" role="listbox">
            <div className="item active">
              {indents}
            </div>

          </div>

          <a className="left carousel-control" href="#myCarousel" role="button" data-slide="prev">
            <span className="glyphicon glyphicon-chevron-left" aria-hidden="true"></span>
            <span className="sr-only">Previous</span>
          </a>
          <a className="right carousel-control" href="#myCarousel" role="button" data-slide="next">
            <span className="glyphicon glyphicon-chevron-right" aria-hidden="true"></span>
            <span className="sr-only">Next</span>
          </a>
        </div>
      </div>
    )
  }

})


module.exports = SectionPromotion



// WEBPACK FOOTER //
// ./js/sectionPromotion.js